<template>
  <Layout>
    <div class="row">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4>Company Settings</h4><br>
            <form @submit.prevent="UpdateSettings">
              <div class="row">


                <div class="col-md-3">


                  <div class="form-group mb-2">
                    <label>Show Detailed Receipt</label>
                    <select class="form-control" v-model="print_trans">
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </select>
                  </div>

                </div>
                <div class="col-md-3">
                  <div class="form-group mb-2">
                    <label>Show Psychology Section</label>
                    <select class="form-control" v-model="psychology">
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </select>
                  </div>
                </div>
                
                <div class="col-md-3">
                  <div class="form-group mb-2">
                    <label>Show Detailed Lab Results</label>
                    <select class="form-control" v-model="show_detailed_lab_results">
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-3">
                    <div class="form-group mb-2">
                      <label>Default Font</label>
                      <select class="form-control" v-model="default_font">
                        <option value="Poppins">Poppins</option>
                        <option value="Arial">Arial</option>
                        <option value="Helvetica">Helvetica</option>
                        <option value="Georgia">Georgia</option>
                        <option value="Times New Roman">Times New Roman</option>
                        <option value="Verdana">Verdana</option>
                        <option value="Tahoma">Tahoma</option>
                        <option value="Trebuchet MS">Trebuchet MS</option>
                        <option value="Courier New">Courier New</option>
                        <option value="Segoe UI">Segoe UI</option>
                      </select>
                    </div>
                </div>

                <div class="col-md-3">

                  <div class="form-group"><br>
                    <b-button
                      type="submit"
                      class="btn w-100 mt-2"
                      variant="primary"
                      :disabled="isUpdating"
                    >
                      <span v-if="isUpdating" class="d-inline-flex align-items-center justify-content-center">
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Updating...
                      </span>
                      <span v-else>
                        <i class="fas fa-check-circle"></i>
                        Update
                      </span>
                    </b-button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Facility Profile",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),

      print_trans: 1,
      psychology: 1,
      show_detailed_lab_results: 0,
      default_font: "Poppins",
      isUpdating: false,

    };
  },
  methods: {

    async UpdateSettings() {
      this.isUpdating = true;
      let formData = new FormData();

      formData.append("print_trans", this.print_trans);
      formData.append("psychology", this.psychology);
      formData.append("show_detailed_lab_results", this.show_detailed_lab_results);
      formData.append("default_font", this.default_font);
      let url = "/updatefacilitysettings";
      try {
        const response = await axios.post(url, formData);
        if (response.status == 200) {
          let userData = response.data.user;
          localStorage.setItem('user', JSON.stringify(userData));
          this.$toast.success(response.data.message || "Settings Updated, Reloading page...", { timeout: 5000 });
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
      } catch (error) {
        this.$toast.error(error?.response?.data?.message || "Failed to update facility settings.");
      } finally {
        this.isUpdating = false;
      }
    },
  },
  mounted() {

    this.print_trans = this.userData.settings.print_trans;
    this.psychology = this.userData.settings.psychology;
    this.show_detailed_lab_results = this.userData.settings.show_detailed_lab_results ?? 0;
    this.default_font = this.userData.settings.default_font || "Poppins";

  },

};
</script>
